import { createSlice }                   from '@reduxjs/toolkit'
import _                                 from 'lodash'
import { doQuote, doQuotePriceSelected } from 'pu-utils/quoteServicesApi';
import { ERROR, PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';
import { parameterForceRequote }         from 'pu-data/Utils';

import {
  USA_QUICKTURN_ID,
  findVariantIdBySupplierCode,
} from 'pu-data/ProductVariants';

import {
  customerRedux,
  areSameBasicParams,
  bestPriceRedux,
  offshoreRedux,
} from './parameteres'

import SupplierTypes from './SupplierTypes'

import DefaultState, {
  validateParametersRules,
  aditionalRules,
} from './default/DefaultState';

import InitialState from './default/InitialState';

import { 
  scrollToFabrication,
  updateProjectNumber,
  addProjectErrors, 
} from '../../project_quote/data/ProjectSlice';

const fabricationService = createSlice({
  name: 'fabricationService',
  initialState: InitialState,
  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload
      customerRedux(state.parametersCustomer, name, value)
      state.sameBasicParams = areSameBasicParams(state.parametersCustomer)
      bestPriceRedux(state.parametersBestPrice, state.parametersCustomer)
      offshoreRedux(state.parametersOffshore, state.parametersCustomer)
      state.parametersChanged = parameterForceRequote(name)

      if (name === 'part_number' || name === 'revision') {
        state.parameters[name] = value
      }
    },

    quoteStart(state) {
      state.loading = true
    },

    quoteSuccess(state, action) {
      state.quote = action.payload
      state.loading = false
      state.parameters.product_quote_number = state.quote.number
      state.parametersCustomer.product_quote_number = state.quote.number

      delete state.parameters.row_selected
      delete state.parameters.column_selected
      delete state.parameters.quote_config_key
      delete state.parameters.supplier_selected
      delete state.parameters.vendor_selected
      delete state.parametersCustomer.row_selected
      delete state.parametersCustomer.column_selected
      delete state.parametersCustomer.quote_config_key
      delete state.parametersCustomer.supplier_selected
      delete state.parametersCustomer.vendor_selected

      state.parametersChanged = false
      state.quoteStep = QUOTED
      state.variantId = USA_QUICKTURN_ID
      state.itemSelected = false
      
      if (!state.firstQuoteMade) {
        state.firstQuoteMade = state.quote.number
      }
    },

    quoteFailure(state) {
      state.loading = false
      state.quote = {}
      state.quoteStep = ERROR
      state.itemSelected = false
    },

    setPriceSelected(state, action) {
      const sp = action.payload
      Object.assign(state.parametersCustomer, {
        row_selected: sp.row_selected,
        column_selected: sp.column_selected,
        quote_config_key: sp.quote_config_key,
        supplier_selected: sp.supplier,
        vendor_selected: sp.supplier,
      })
      state.quoteStep = PRICE_SELECTED
      state.sameBasicParams = areSameBasicParams(state.parametersCustomer)

      bestPriceRedux(state.parametersBestPrice, state.parametersCustomer)

      state.parameters = _.endsWith(sp.quote_config_key, '-grpa')
        ? state.parametersBestPrice
        : state.parametersCustomer;

      offshoreRedux(state.parametersOffshore, state.parametersCustomer)
      state.showSummary = true
      state.itemSelected = true
      state.variantId = findVariantIdBySupplierCode(sp.supplier)
    },

    formValidated(state, action) {
      state.errors = action.payload
    },
    allowEdit(state) {
      state.showSummary = false
    },
    deleteQuote(state) {
      Object.assign(state, DefaultState)
    },
  },
})

export const {
  changeParameter,
  quoteStart,
  quoteSuccess,
  quoteFailure,
  setPriceSelected,
  formValidated,
  allowEdit,
  deleteQuote,
} = fabricationService.actions

export default fabricationService.reducer

const validateParameters = (parameters) => {
  const errors = {}
  Object.keys(parameters).forEach((key) => {
    if (!validateParametersRules[key]) return;
    const newError = validateParametersRules[key](parameters[key]);
    if (newError) {
      errors[key] = newError
    }
  });

  Object.entries(aditionalRules).forEach(([key, rule]) => {
    const newError = rule(parameters);
    if (newError) {
      errors[key] = newError
    }
  });

  return errors;
}

export const fetchQuote = (
  suppliers,
  parameters,
  sameBasicParams,
  authToken,
  variantId
) => async (dispatch) => {
  try {
    const options = {};

    if (parameters.parametersCustomer.finish_plating === 'ENIG') {
      if (!sameBasicParams) {
        options[SupplierTypes.PLX_BEST_PRICE] = parameters.parametersBestPrice
      }
      options[SupplierTypes.PLX_QUOTE] = parameters.parametersCustomer
      options[SupplierTypes.EXCEL_QUOTE] = parameters.parametersCustomer
      options[SupplierTypes.AMPEL_QUOTE] = parameters.parametersCustomer
    } else {
      options[SupplierTypes.PLX_BEST_PRICE] = parameters.parametersBestPrice
      options[SupplierTypes.PLX_QUOTE] = parameters.parametersCustomer
      options[SupplierTypes.EXCEL_QUOTE] = parameters.parametersCustomer
      options[SupplierTypes.AMPEL_QUOTE] = parameters.parametersCustomer
    }
    options[SupplierTypes.WHX_QUOTE] = parameters.parametersOffshore
    options[SupplierTypes.JETPCB_QUOTE] = parameters.parametersOffshore

    const errors = validateParameters(parameters.parametersCustomer);
    if (errors && Object.keys(errors).length) {
      dispatch(formValidated(errors))
      scrollToFabrication()
      return;
    }

    dispatch(formValidated({}))
    dispatch(quoteStart())
    // const response = await getQuote()
    const bundle_number = document.getElementById('bundle_number').value;
    const bundle_variant_id = document.getElementById('variant_id').value;
    const response = await doQuote(options, authToken, variantId, parameters.parametersCustomer.quote_number, bundle_number, bundle_variant_id)
    dispatch(quoteSuccess(response))

    document.getElementsByName('bundle_number')[0].value = response.bundle_id
    dispatch(updateProjectNumber(response))
  } catch (err) {
    dispatch(quoteFailure(err.toString()))
    dispatch(addProjectErrors('The site could not get a quote for the Fabrication Service, please try again later.'))
  }
}

export const priceSelected = (data, authToken, number) => async (dispatch) => {
  try {
    dispatch(setPriceSelected(data))
    await doQuotePriceSelected(data, authToken, number)
  } catch (err) {
    // error
  }
}
